module.exports = __webpack_public_path__ + "img/龙宫男.8496730c.png";